export default __webpack_public_path__ + "static/percebes-f37cbc80f0026138e6729801d04c1070.jpg";